// Create a module-level variable to hold the loaded config
let appConfig = null;



// Export a setter to store the loaded config
export const SetAppConfig = (config) => {

    // Save the config into the module-level variable
    appConfig = config;

};



// Export a getter to read the stored config
export const GetAppConfig = () => {

    // If config has not been set yet
    if (!appConfig) {

        // Throw a useful error so the issue is obvious
        throw new Error("App config has not been set yet.");

    }

    // Return the stored config
    return appConfig;

};